/* eslint-disable react/no-array-index-key,react/prop-types */
import React from 'react';
import Money from '../../../../components/Money';

const getQuantityByType = (item) => {
  let { service, product } = item.quantityByType;
  service = service && (service <= 1 ? `${service} service` : `${service} services`);
  product = product && (product <= 1 ? `${product} product` : `${product} products`);
  return [service, product].filter(Boolean).join(' + ');
};

const Breakdown = ({
  total,
  date,
  datetime,
  subtotal,
  tip,
  taxesAndFees,
  promo,
  promoCode,
  discount,
  items,
  totalByType,
  giftCardCode,
  last4,
  brand,
  transactionId,
  refunded,
}) => (
  <div>
    <div className="u-flex u-align-center u-justify-content-space-between">
      <div>
        <div className="u-text-large u-fw-bold">Total price</div>
        <div className="u-text-medium u-co-grey">Incl. all taxes & fees</div>
      </div>
      <div
        className="c-receipt-total u-ta-right"
        style={{ fontSize: '48px !important', lineHeight: '48px !important' }}
      >
        <Money noDecimalsIfInt>
          {total}
        </Money>
      </div>
    </div>
    <div className="c-divider u-mt-5 u-mb-5" />
    <div className="u-flex u-justify-content-space-between u-mb-8">
      <div>
        <div className="u-text-extrasmall u-co-grey--light u-tt-uppercase u-fw-bold u-mb-1">
          Date
        </div>
        <div>
          <div className="u-text-normal">
            {date}
          </div>
        </div>
      </div>
      <div>
        <div className="u-text-extrasmall u-co-grey--light u-tt-uppercase u-fw-bold u-ta-right u-mb-1">
          Time
        </div>
        <div className="u-text-normal u-ta-right">
          {datetime}
        </div>
      </div>
    </div>
    {
      items.map((item, idx) => (
        <div key={idx}>
          <div className="u-flex u-justify-content-space-between u-align-center u-mt-8 u-mb-4">
            <div className="u-text-normal u-fw-bold">
              {item.barberName}
            </div>
            <div
              className="u-text-small u-co-grey u-float-right u-hide-on-mobile"
              style={{ lineHeight: '22px !important' }}
            >
              {getQuantityByType(item)}
            </div>
          </div>
          {
            item.subItems.map((subItem, innerIdx) => (
              <div className="u-flex u-justify-content-space-between u-align-center u-mb-2" key={innerIdx}>
                <div>
                  <span className="c-items-count">
                    {subItem.quantity}
                  </span>
                  <span
                    className="u-text-normal u-co-grey"
                    style={{ lineHeight: '20px !important' }}
                  >
                    {subItem.name}
                  </span>
                </div>
                <div className="u-text-normal">
                  <Money noDecimalsIfInt>
                    {subItem.amount}
                  </Money>
                </div>
              </div>
            ))
          }
          {
            !!item.tip && (
              <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
                <div>
                  <span style={{ display: 'inline-block', minWidth: '30px' }} />
                  <span className="u-text-normal u-co-grey">
                    Tip
                  </span>
                </div>
                <div className="u-text-normal">
                  <Money noDecimalsIfInt>
                    {item.tip}
                  </Money>
                </div>
              </div>
            )
          }
        </div>
      ))
    }
    <div className="c-divider u-mt-8 u-mb-6" />
    <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
      <div className="u-text-normal u-co-grey">
        Subtotal
      </div>
      <div className="u-text-normal">
        <Money noDecimalsIfInt>{subtotal}</Money>
      </div>
    </div>
    {
      !!tip && (
        <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
          <div className="u-text-normal u-co-grey">
            Tip
          </div>
          <div className="u-text-normal">
            <Money noDecimalsIfInt>{tip}</Money>
          </div>
        </div>
      )
    }
    {
      !!taxesAndFees && (
        <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
          <div className="u-text-normal u-co-grey">
            Taxes & fees
          </div>
          <div className="u-text-norma">
            <Money noDecimalsIfInt>{taxesAndFees}</Money>
          </div>
        </div>
      )
    }
    {
      !!promo && (
        <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
          <div className="u-text-normal u-co-grey">
            Promo – {promoCode}
          </div>
          <div className="u-text-normal u-co-green">
            -<Money noDecimalsIfInt>{promo}</Money>
          </div>
        </div>
      )
    }
    {
      !!discount && (
        <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
          <div className="u-text-normal u-co-grey">
            Discount
          </div>
          <div className="u-text-normal u-co-green">
            -<Money noDecimalsIfInt>{discount}</Money>
          </div>
        </div>
      )
    }
    {
      !!refunded && (
        <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
          <div className="u-text-normal u-co-red u-fw-bold">
            Refunded
          </div>
          <div className="u-text-normal u-co-red u-fw-bold">
            <Money noDecimalsIfInt>{refunded}</Money>
          </div>
        </div>
      )
    }
    <div className="c-divider u-mt-8 u-mb-8" />
    <div className="u-mb-16">
      {
        !!totalByType.card && (
          <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
            <div className="u-flex u-justify-content-space-between u-align-center">
              <img
                width="38px"
                height="24px"
                className="u-mr-4"
                src={`https://squire-emails.s3-us-west-1.amazonaws.com/images/logo-${brand}.png`}
                alt=""
              />
              <div className="u-text-normal u-fw-bold">
                •••• {last4}
              </div>
            </div>
            <div className="u-text-normal">
              <Money noDecimalsIfInt>
                {totalByType.card}
              </Money>
            </div>
          </div>
        )
      }
      {
        !!totalByType.giftCard && (
          <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
            <div className="u-flex u-justify-content-space-between u-align-center">
              <img
                width="38px"
                height="24px"
                className="u-mr-4"
                src="https://squire-emails.s3-us-west-1.amazonaws.com/images/logo-gift-card.png"
                alt=""
              />
              <div className="u-text-normal u-fw-bold">
                Gift Card: {giftCardCode}
              </div>
            </div>
            <div className="u-text-normal u-co-green">
              <Money noDecimalsIfInt>
                {totalByType.giftCard}
              </Money>
            </div>
          </div>
        )
      }
      {
        !!totalByType.cash && (
          <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
            <div className="u-flex u-justify-content-space-between u-align-center">
              <img
                width="38px"
                height="24px"
                className="u-mr-4"
                src="https://squire-emails.s3-us-west-1.amazonaws.com/images/logo-cash.png"
                alt=""
              />
              <div className="u-text-normal u-fw-bold">
                Cash
              </div>
            </div>
            <div className="u-text-normal">
              <Money noDecimalsIfInt>
                {totalByType.cash}
              </Money>
            </div>
          </div>
        )
      }
      <div className="u-mt-5 u-text-tiny u-co-grey--light u-ta-center u-hide-on-mobile">
        <span className="u-mr-5">AID {transactionId}</span>
        <span className="u-mr-5">{date}</span>
        <span>{datetime}</span>
      </div>
      <div className="u-mt-5 u-text-tiny u-co-grey--light u-ta-center u-hide-on-desktop">
        <div className="u-mb-2">AID {transactionId}</div>
        <div>{date} {datetime}</div>
      </div>
    </div>
  </div>
);

export default Breakdown;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Receipt/components/Breakdown.jsx